import type { MarketMetadata } from '@//market';

// Canonical URLs always use the www subdomain so Google sees a single
// authoritative URL per page regardless of which host the request came in on.
export const buildCanonicalUrl = (marketMetadata: MarketMetadata, path = ''): string => {
  const baseUrl = marketMetadata.url.includes('://www.')
    ? marketMetadata.url
    : marketMetadata.url.replace('://', '://www.');
  return `${baseUrl}${path}`;
};
